export const canClearNodeText = () => () => {
    return function (nodes) {
        return [...nodes].filter(
            node => this.actions.canClearNodeText(node)
        )
    }
}

export const clearNodeText = () => () => {
    return async function (nodes) {
        await this.execute(
            () => this.actions.clearNodeText(nodes)
        )
    }
}
